import { Action } from '../actions/geo-ip';

const defaultState = {
  isFetching: false,
  geoIpInfo: {},
  error: undefined,
};

export default function geoIpReducer(state = defaultState, action) {
  const body = action?.payload;

  switch (action?.type) {
    case Action.GeoIp.GeoIpCompleted:
      return {
        ...state,
        isFetching: false,
        geoIpInfo: body,
      };

    case Action.GeoIp.GeoIpFailed:
      return {
        ...state,
        isFetching: false,
        error: body,
      };

    case Action.GeoIp.GeoIpPending:
      return {
        ...state,
        error: undefined,
        isFetching: true,
        geoIpInfo: {},
      };

    default:
      return state;
  }
}
